import React from "react";
import LicenseStatus from "license/LicenseStatus";
const StatusCell = ({ status }) => /* @__PURE__ */ React.createElement(LicenseStatus, { status });
export default StatusCell;
